import { render, staticRenderFns } from "./ModificarCodigos.vue?vue&type=template&id=b15f99f8&scoped=true&"
import script from "./ModificarCodigos.vue?vue&type=script&lang=js&"
export * from "./ModificarCodigos.vue?vue&type=script&lang=js&"
import style0 from "./ModificarCodigos.vue?vue&type=style&index=0&id=b15f99f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15f99f8",
  null
  
)

export default component.exports